import {
  CHOICE_STEP_BY_SCREEN,
  MULTI_STEP_BY_SCREEN,
  TEXT_STEP_BY_SCREEN,
  ONBOARDING_INTRO_SCREEN,
  ONBOARDING_PITCH_SCREEN,
  ONBOARDING_PHONE_HOURS_SCREEN,
  ONBOARDING_PHONE_MATH_SCREEN,
  ONBOARDING_RECLAIM_SCREEN,
  ONBOARDING_REFLECTION_SCREEN,
  ONBOARDING_PLAN_LOADING_SCREEN,
  ONBOARDING_SOCIAL_PROOF_SCREEN,
} from './onboardingConfig';

// Public URLs follow the visible funnel order rather than the historical
// analytics screen ids. Retired screens therefore never create gaps in q1…qN.
export const WEB_ONBOARDING_ROUTE_SCREENS = [
  ONBOARDING_INTRO_SCREEN,
  ONBOARDING_PITCH_SCREEN,
  5,
  6, // Reserved legacy company URL; redirected to the next question.
  8,
  ONBOARDING_PHONE_HOURS_SCREEN,
  ONBOARDING_PHONE_MATH_SCREEN,
  ONBOARDING_RECLAIM_SCREEN,
  12,
  13,
  14,
  15,
  ONBOARDING_REFLECTION_SCREEN,
  24,
  ONBOARDING_PLAN_LOADING_SCREEN,
  ONBOARDING_SOCIAL_PROOF_SCREEN,
] as const;

const answerScreens = WEB_ONBOARDING_ROUTE_SCREENS.filter(screen =>
  CHOICE_STEP_BY_SCREEN.has(screen) || MULTI_STEP_BY_SCREEN.has(screen) ||
  TEXT_STEP_BY_SCREEN.has(screen) || screen === ONBOARDING_PHONE_HOURS_SCREEN,
);

export type NameStepArm = 'control' | 'no_name';

export function resolveNameStepScreen(screen: number, arm: NameStepArm, direction: 'forward' | 'backward' = 'forward') {
  if (screen === 6) return direction === 'forward' ? 8 : arm === 'no_name' ? ONBOARDING_PITCH_SCREEN : 5;
  if (screen !== 5 || arm !== 'no_name') return screen;
  return direction === 'backward' ? ONBOARDING_PITCH_SCREEN : 8;
}

export function getWebQuizQuestionProgress(screen: number, arm: NameStepArm = 'control') {
  const index = WEB_ONBOARDING_ROUTE_SCREENS.indexOf(screen as typeof WEB_ONBOARDING_ROUTE_SCREENS[number]);
  if (index <= 0) return null;

  // Explanations keep the preceding question number; the opening pitch introduces question 1.
  const visibleAnswerScreens = arm === 'no_name' ? answerScreens.filter(item => item !== 5) : answerScreens;
  const reached = WEB_ONBOARDING_ROUTE_SCREENS.slice(0, index + 1).filter(item => visibleAnswerScreens.includes(item)).length;
  return { current: Math.max(1, reached), total: visibleAnswerScreens.length };
}

export function getWebOnboardingPath(screen: number) {
  const index = WEB_ONBOARDING_ROUTE_SCREENS.indexOf(
    screen as (typeof WEB_ONBOARDING_ROUTE_SCREENS)[number],
  );

  if (index < 0) {
    return null;
  }

  return index === 0 ? '/start' : `/start/q${index}`;
}

export function getWebOnboardingScreenForPath(pathname: string) {
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/u, '') : pathname;

  if (normalizedPath === '/start') {
    return ONBOARDING_INTRO_SCREEN;
  }

  const match = normalizedPath.match(/^\/start\/q([1-9]\d*)$/u);

  if (!match) {
    return null;
  }

  const questionIndex = Number(match[1]);
  return WEB_ONBOARDING_ROUTE_SCREENS[questionIndex] ?? null;
}
